<template>
  <div class="schedule" >
    <el-divider content-position="left">待办事项分类列表</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.category_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCfcategory"
        :loading="searchLoading"
        @change="handleSearchCfcategory"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.title"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="categoryIn"
          >录入</el-button
        >
        <a href="/schedule_cate">
          <el-button type="warning" size="mini">分类</el-button>
        </a>
        <a href="/schedule_address">
          <el-button type="success" size="mini">地点</el-button>
        </a>
      </div>
    </div>
    <el-drawer
      title="录入"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryForm"
          :rules="rules"
          ref="categoryForm"
          label-width="100px"
        >
          <el-form-item label="所属分类" prop="categoryId">
            <el-select
              v-model="categoryForm.categoryId"
              placeholder="请选择"
              clearable
              filterable
              size="mini"
              style="width: 100%"
              @click.native="loadCategory"
            >
              <el-option
                v-for="item in categoryIdOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称" prop="title">
            <el-input v-model="categoryForm.title" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="办理时长" prop="duration">
            <el-input
              v-model="categoryForm.duration"
              size="mini"
              type="number"
              placeholder="单位分钟"
            ></el-input>
          </el-form-item>
          <el-form-item label="绩效金额" prop="money">
            <el-input
              v-model="categoryForm.money"
              size="mini"
              placeholder="输入数字"
            ></el-input>
          </el-form-item>
          <el-form-item label="保底数量" prop="num">
            <el-input
              v-model="categoryForm.num"
              size="mini"
              placeholder="输入数字"
            ></el-input>
          </el-form-item>
          <el-form-item label="内容详情" prop="content">
            <el-input
              size="mini"
              type="textarea"
              v-model="categoryForm.content"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="categoryForm.display"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('categoryForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editCategoryForm"
          :rules="rules"
          ref="editCategoryForm"
          label-width="100px"
        >
          <el-form-item label="所属分类" prop="categoryId">
            <el-select
              v-model="editCategoryForm.categoryId"
              placeholder="请选择"
              clearable
              filterable
              size="mini"
              style="width: 100%"
              @click.native="loadCategory"
            >
              <el-option
                v-for="item in categoryIdOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称" prop="title">
            <el-input v-model="editCategoryForm.title" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="办理时长" prop="duration">
            <el-input
              v-model="editCategoryForm.duration"
              size="mini"
              type="number"
              placeholder="单位分钟"
            ></el-input>
          </el-form-item>
          <el-form-item label="绩效金额" prop="money">
            <el-input
              v-model="editCategoryForm.money"
              size="mini"
              placeholder="输入数字"
            ></el-input>
          </el-form-item>
          <el-form-item label="保底数量" prop="num">
            <el-input
              v-model="editCategoryForm.num"
              size="mini"
              placeholder="输入数字"
            ></el-input>
          </el-form-item>
          <el-form-item label="内容详情" prop="content">
            <el-input
              size="mini"
              type="textarea"
              v-model="editCategoryForm.content"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="editCategoryForm.display"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('editCategoryForm')"
              >保存</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-table
    height="calc(100vh - 266px)"
      :data="categoryData"
      style="width: 100%;margin-top: 10px;"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="id" label="ID" fixed> </el-table-column>
      <el-table-column prop="cate.category_name" label="所属分类">
      </el-table-column>
      <el-table-column prop="title" label="名称"> </el-table-column>
      <el-table-column prop="content" label="内容详情"> </el-table-column>
      <el-table-column prop="duration" label="办理时长">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="tableEdit.duration[scope.row.id]"
            @blur="editTableData_duration(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="绩效金额">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="tableEdit.money[scope.row.id]"
            @blur="editTableData_money(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="num" label="保底数量">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="tableEdit.num[scope.row.id]"
            @blur="editTableData_num(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="display" label="是否显示">
        <template slot-scope="scope">
          是
          <el-switch
            v-model="ListIfDisplay[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @click.native="editListRadio(scope.row)"
          >
          </el-switch>
          否
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.row)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-footer">
      <el-pagination
      class="pagination-style"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cfcatetgory',
  data () {
    var numReg = /^[0-9]*$/
    var numRe = new RegExp(numReg)
    var checkDuration = (rule, value, callback) => {
      if (!numRe.test(value)) {
        return callback(new Error('请输入数字！'))
      }
      callback()
    }
    var categoryId = (rule, value, callback) => {
      if (value.length > 100) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入分类名称！'))
      }
      callback()
    }
    var validateLength = (rule, value, callback) => {
      if (!value) {
        callback()
      } else {
        var reg = /^-?\d{1,4}(?:\.\d{1,4})?$/ // 小数点左边最高4位，小数点右边最多4位
        if (reg.test(value)) {
          callback()
        } else {
          callback(new Error('输入正确的数字,小数点后可1到4位'))
        }
      }
    }
    return {

      searchArr: {
        category_id: ''
      },
      categoryIdOptions: [],
      npage: 1,
      categoryPerPage: 30,
      total: null,
      listSortForm: [],
      categoryData: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      categoryIndrawer: false,
      direction: 'rtl',
      ifDisplay: false,
      ListIfDisplay: [],
      listSort: [],
      category: '',
      categoryForm: {
        content: '',
        duration: '',
        title: '',
        categoryId: '',
        display: false,
        money: '',
        num: ''
      },
      editCategoryForm: {
        content: '',
        duration: '',
        title: '',
        categoryId: '',
        display: false,
        money: '',
        num: ''
      },
      tableEdit: {
        money: [],
        num: [],
        duration: []
      },
      rules: {
        categoryId: [
          { required: true, message: '请选择所属分类', trigger: 'blur' },
          {
            validator: categoryId,
            trigger: 'blur'
          }
        ],
        title: [
          { required: true, message: '请填写名称', trigger: 'blur' },
          {
            max: 100,
            message: '长度最多 100 个字符',
            trigger: 'blur'
          }
        ],
        duration: [
          { required: true, message: '请填写办理时长', trigger: 'blur' },
          {
            validator: checkDuration,
            trigger: 'blur'
          }
        ],
        money: [
          {
            validator: validateLength,
            trigger: 'blur'
          }
        ],
        num: [
          {
            validator: checkDuration,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted () {
    this.loadTable()
  },
  // watch: {
  //   searcher: function (n, o) {
  //     this.loadTable(n)
  //   }
  // },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    loadTable () {
      this.$axios
        .get('api/schedulesecond/index', {
          params: {
            page: this.npage,
            perpage: this.categoryPerPage,
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data
            this.total = data.data.total
            this.loadRadio()
            this.loadSort()
          }
        })
        .catch()
    },
    loadRadio () {
      this.categoryData.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSort () {
      this.categoryData.map(item => {
        this.listSort[item.id] = Number(item.sort)
        this.tableEdit.money[item.id] = Number(item.money)
        this.tableEdit.num[item.id] = Number(item.num)
        this.tableEdit.duration[item.id] = Number(item.duration)
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadTable()
    },
    editRow (row) {
      this.categoryIdOptions.push(row.cate)
      this.editCategoryForm = row
      if (row.display === 1) {
        this.editCategoryForm.display = false
      } else {
        this.editCategoryForm.display = true
      }
      this.editCategoryForm.id = row.id
      this.categoryEditDrawer = true
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/schedulesecond/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    handleSearchCfcategory (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    categoryIn () {
      this.categoryIndrawer = true
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/schedulesecond/store', this.categoryForm)
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.categoryIndrawer = false
                this.resetForm('categoryForm')
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    editSubmitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .put('api/schedulesecond/edit', this.editCategoryForm)
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.categoryEditDrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editListRadio (row) {
      this.$axios
        .put('api/schedulesecond/listshow', {
          id: row.id,
          display: this.ListIfDisplay[row.id] === false ? 1 : 0
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .put('api/schedulesecond/setsort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadCategory () {
      this.$axios
        .get('api/schedulesecond/getcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryIdOptions = data.data
          }
        })
        .catch()
    },
    editTableData_money (row) {
      var reg = /^-?\d{1,4}(?:\.\d{1,4})?$/ // 小数点左边最高4位，小数点右边最多4位
      if (!reg.test(this.tableEdit.money[row.id])) {
        this.$message.warning('请输入正确的金额，小数点后1-4位')
        return false
      }
      this.$axios
        .put('api/schedulesecond/singleaddmoney?id=' + row.id, {
          money: this.tableEdit.money[row.id]
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    editTableData_num (row) {
      var numReg = /^[0-9]*$/
      var numRe = new RegExp(numReg)
      if (!numRe.test(this.tableEdit.num[row.id])) {
        this.$message.warning('请输入数字！')
        return false
      }
      this.$axios
        .put('api/schedulesecond/singleaddnum?id=' + row.id, {
          num: this.tableEdit.num[row.id]
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    editTableData_duration (row) {
      var numReg = /^[0-9]*$/
      var numRe = new RegExp(numReg)
      if (!numRe.test(this.tableEdit.duration[row.id])) {
        this.$message.warning('请输入数字！')
        return false
      }
      this.$axios
        .put('api/schedulesecond/singleaddduration?id=' + row.id, {
          duration: this.tableEdit.duration[row.id]
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    }
  }
}
</script>

<style  scoped>
.schedule {
  /* margin-left: 1.25rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 25px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/schedule/Schedule.vue